<template>
  <div ref="iframeContainer" class="game-frame-body">
    <!-- Test buttons -->
    <!-- <div style="position: absolute; top:0;right:0; backgroundColor:white; zIndex:10000;">
      <button @click="eventW2G({ data: JSON.stringify({ _type: 'ucip.autoplay.w2gInterruptGameplayCommand' })})">AutoplayOff</button>
      <button @click="eventW2G({ data: JSON.stringify({ _type: 'ucip.pause.w2gPauseCommand', pause: true })})">StopGame</button>
      <button @click="eventW2G({ data: JSON.stringify({ _type: 'ucip.pause.w2gPauseCommand', pause: false })})">ResumeGame</button>
    </div> -->
    <iframe
      id="IFRAME"
      title="Game Container"
      ref="iframe"
      class="main-i-frame"
      :class="{'cz-regulatory' : isCZRegulatory, 'sk-regulatory' : isSkRegulatory}"
      frameborder="0"
      clienting="no"
      data-ratio="0"
      :src="gameFrameUrl"
      :allow="(isSkRegulatory || isCZRegulatory) ? '' : 'autoplay *; screen-wake-lock *; fullscreen *'"
      :style="iframeStyle"
      @load="gameLoad"
    />
  </div>
</template>

<script>
import titleMixin from '@/mixins/titleMixin';
import GameCommunicatorPNG from '@/helper/GameCommunicators/GameCommunicatorPNG.js';
import GameCommunicatorNovomatic from '@/helper/GameCommunicators/GameCommunicatorNovomatic.js';
import GameCommunicatorDefault from '@/helper/GameCommunicators/GameCommunicatorDefault.js';

export default {
  name: 'MainProvidersView',
  mixins: [titleMixin],
  title() {
    const routeQuery = this.$route.query;
    const routeParams = this.$route.params;
    return routeQuery.gameName ? `${routeQuery.gameName}` : `${routeParams.provider}`;
  },
  props: {
    isCZRegulatory: { type: Boolean, default: false },
    isSkRegulatory: { type: Boolean, default: false },
  },
  data() {
    return {
      gameFrameUrl: '',
      gameCloseRedirectUrl: '',
      iframeStyle: '',
      GameCommunicator: '',
      isGameReady: true,
      stopGame: false,
      wrapperEvent: false
    }
  },
  computed: {
    isProviderEgt: vm => vm.$route.params.provider.toUpperCase() === 'EGT',
    isProviderNovomatic: vm => vm.$route.params.provider.toUpperCase() === 'NOVOMATIC',
    isProviderPlayNGo: vm => vm.$route.params.provider.toUpperCase() === 'PLAYNGO',
  },
  watch: {
    $route () { if(this.isProviderPlayNGo) this.gameFrameUrl = this.$route.query.gameURL; }
  },
  created() {
    this.gameCloseRedirectUrl = this.$route.query.closeurl;
    this.gameFrameUrl = this.$route.query.gameURL;
  },
  methods: {
    createWrapperComunication() {
      const parentWindow = window.parent;
      if(parentWindow) {
        this.generateWrapperMessage({
          _type: "ucip.basic.g2wInitializationRequest",
          version: "1.0.0",
          features: ["pause", "autoplay"]
        });
      }
      window.addEventListener('message', this.receiveMessage, false)
    },
    gameLoad() {
      console.log('%c Loaded! ', 'background: #222; color: yellow');

      this.$emit('iframeRefChange', this.$refs.iframe);
      this.createWrapperComunication();

      if(this.isProviderPlayNGo) {
        this.GameCommunicator = new GameCommunicatorPNG(this);
        this.onWindowLoadPNG();
      } else if(this.isProviderNovomatic) {
        this.GameCommunicator = new GameCommunicatorNovomatic(this);
        this.onWindowLoadNovomatic();
      } else {
        this.GameCommunicator = new GameCommunicatorDefault(this);
      }
    },
    onExitGamePlatform() { window.top.location.href = this.gameCloseRedirectUrl; },
    isEventClosing(e) {
      if(!e.data) return false;

      let novomaticData = '';
      if(this.isProviderNovomatic) {
        try { novomaticData = JSON.parse(e.data); }
        catch(error) { return false; }
      }

      // ca-client-redirect is used by CTI
      const command = e.data.command;
      const isClosingEGT = command == 'com.egt-bg.exit' || command == 'com.egt-bg.launchLobby'
      const isClosingGeneral = command == 'exit' || command == 'ca-client-redirect'
      const isClosingNovomatic = novomaticData.event && novomaticData.event.name == 'gameClosing'
      const isClosingPateplay = e.data.event === 'exit'

      const closingEvents = isClosingEGT || isClosingGeneral || isClosingNovomatic || isClosingPateplay

      return closingEvents;
    },
    eventW2G(e) {
      let data;
      this.wrapperEvent = false;
      try { data = JSON.parse(e.data) }
      catch (e) { return }
      if(data._type) {
        switch(data._type) {
          case 'ucip.pause.w2gPauseCommand':
            if(data.pause) {
              this.stopGame = true;
              this.GameCommunicator.postMessage('stopGame');
            } else {
              this.stopGame = false;
              this.GameCommunicator.postMessage('resumeGame');
            }
            this.wrapperEvent = true;
            break;
          case 'ucip.autoplay.w2gInterruptGameplayCommand':
            this.GameCommunicator.postMessage('autoplayOff')
            this.wrapperEvent = true;
            break;
          case 'ucip.basic.w2gInitializationResponse':
            this.wrapperEvent = true;
            break;
        }
      }
    },
    autoplayStarted() { this.generateWrapperMessage({ _type: 'ucip.autoplay.g2wAutoplayStartNotification' }); },
    autoplayStopped() { this.generateWrapperMessage({ _type: 'ucip.autoplay.g2wAutoplayEndNotification' }); },
    gameStopped() { this.generateWrapperMessage({ _type: 'ucip.pause.g2wPauseNotification', pause: true }); },
    gameStarted() { this.generateWrapperMessage({ _type: 'ucip.pause.g2wPauseNotification', pause: false }); },
    gameRedirect(eData) {
      console.log('Handle popActionRedirect:', eData);
      window.parent.postMessage(eData, '*');
    },
    receiveMessage(event) {
      this.eventW2G(event);
      if(this.wrapperEvent) return;
      if(this.isEventClosing(event)) this.onExitGamePlatform();
      if(event.data._type === 'popActionRedirect') this.gameRedirect(event.data);
    },
    onWindowLoadPNG() {
      this.GameCommunicator.init(this.$refs.iframe);
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'reloadGame' });
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'backToLobby' });
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'autoplayEnded' });
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'autoplayStarted' });
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'gameDisabled' });
      this.GameCommunicator.postMessage({ messageType: 'addEventListener', eventType: 'gameEnabled' });
    },
    onWindowLoadNovomatic() { this.GameCommunicator.init(this.$refs.iframe); },
    generateWrapperMessage(message) {
      const triggerMessage = JSON.stringify(message);
      console.log('GameCommunicator to parent:', triggerMessage);
      window.parent.postMessage(triggerMessage, '*');
    }
  }
}
</script>

<style lang="scss" scoped>
.game-frame-body {
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #17171b;

  .main-i-frame {
    position: absolute;
    overflow: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: none;
    width: 100%;
    height: 100%;
    background-color: black;
  }

.cz-regulatory {
    top: 30px !important;
    height: calc(100% - 60px) !important;
  }

  .sk-regulatory {
    height: calc(100% - 30px) !important;
  }
}
</style>
